export const columns = [
	{ id: "model", label: "Модель", minWidth: 100 },
	{ id: "driver", label: "Водій", minWidth: 100 },
	{ id: "number", label: "Номер", minWidth: 65 },
	{ id: "trackId", label: "MegaGPS ID", minWidth: 100 },
	{ id: "buttons", label: "", minWidth: 65 },
];

export const emptyVan = {
	id: "new-van-id",
	trackId: "",
	userId: null,
	user: null,
	model: "",
	number: "",
};
